function EventsController(){
	this.className	= "EventsController";
	this.glob		= "/events**";
	this.debug		= false;
};
EventsController.inheritsFrom( StandardController );
EventsController.prototype.swap = function(onComplete){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
	this.$latestNews 		= $('.js-latest-event');
	this.$moreEventsButton = $('.js-more-events-button');
	this.$loadingEventsMessage = $('.js-loading-events-message');
	
	this.eventsPagination = 0;

	this.$moreEventsButton.on('click', Igloo.delegate(this, this.loadMoreEvents));

};
EventsController.prototype.loadMoreEvents = async function() {
	
	this.$moreEventsButton.toggleClass('hide');
	this.$loadingEventsMessage.toggleClass('hide');

	this.eventsPagination++;
	const eventGroups = await this.ajax({
		eventsPagination: this.eventsPagination,
  });
  
	if (eventGroups) {

    let canScrollToEvent = true;
    
    for (const group in eventGroups) {
      const groupData = eventGroups[group];

      const newEvents = groupData['events'];

      newEvents.forEach((newEvent) => {
        const monthId = group;
        const monthName = groupData['title'];
        this.addEventToDom(newEvent, monthId, monthName);

        if (canScrollToEvent) {
          canScrollToEvent = false;
          $('html, body').animate({
            scrollTop: $(".item:last-child").offset().top - 30
          }, 500);          
        }

      });	

    }		
    
	} else {
		this.$moreEventsButton.hide();
	}

}
EventsController.prototype.ajax = async function(data) {
  return $.ajax({
    url: '/events/more',
    data: data,
    method: "post"
  }).then(result => {
		const json = JSON.parse(result);
    const items = json['events'];
		
		this.$moreEventsButton.toggleClass('hide');
		this.$loadingEventsMessage.toggleClass('hide');

		if(!json['has_more_events']) this.$moreEventsButton.hide();
		
		// jcache.clearCache();
    return items;
  })
}
EventsController.prototype.addEventToDom = function(eventData, monthId, monthName) {

  // Get events container based on month id.
  let eventsContainer = document.querySelector(`[data-month="${monthId}"] .list`);

  // Creates a new event container if it doesn't exist yet.
  if (!eventsContainer) {
    const monthsContainer = document.querySelector('.months-container');
    
    monthGroup = document.createElement('div');
    monthsContainer.appendChild(monthGroup);
    monthGroup.className = 'page-content month-group';
    monthGroup.dataset.month = monthId;

    const monthContainer = document.createElement('div');
    monthGroup.appendChild(monthContainer);
    monthContainer.className = 'col-12 col-sm-8 left-sm-2 month-container';

    const month = document.createElement('div');
    monthContainer.appendChild(month);
    month.className = 'left-sm-0-5 f-title';
    month.innerHTML = monthName;

    const allEvents = document.createElement('div');
    monthGroup.appendChild(allEvents);
    allEvents.className = 'all-events col-12 mt-sm-1';

    const list = document.createElement('div');
    allEvents.appendChild(list);
    list.className = 'list';

    eventsContainer = document.querySelector(`[data-month="${monthId}"] .list`);       
  }

	const event = document.createElement('div');
	eventsContainer.appendChild(event);
  event.className = 'item pt-4-5';
  
  const numberColumn = document.createElement('div');
  event.appendChild(numberColumn);
  numberColumn.className = 'col-12 col-sm-1 left-sm-1';

  const number = document.createElement('div');
  numberColumn.appendChild(number);
  number.className = 'number stroke-and-glow colour-primary';

  const stroke = document.createElement('div');
  number.appendChild(stroke)
  stroke.className = 'stroke';
  stroke.innerHTML = eventData['date_day'];

  const glow = document.createElement('div');
  number.appendChild(glow)
  glow.className = 'glow';
  glow.innerHTML = eventData['date_day'];  

	const detailsColumn = document.createElement('div');
	event.appendChild(detailsColumn);
	detailsColumn.className = 'col-12 col-sm-5 left-sm-0-5 right-sm-1-5';

  const title = document.createElement('div');
	detailsColumn.appendChild(title);
	title.className = "title pt-2 pt-sm-0";
	title.innerHTML = eventData.title;

	const description = document.createElement('div');
  detailsColumn.appendChild(description);
  description.className = 'description pt-2 pt-sm-1-5';
  description.innerHTML = eventData.excerpt;
  
	const date = document.createElement('div');
  detailsColumn.appendChild(date);
  date.className = 'date pt-2 pt-sm-1-5';
  date.innerHTML = eventData.datetime;
  
  const buttonColumn = document.createElement('div');
	event.appendChild(buttonColumn);
	buttonColumn.className = 'col-12 col-sm-2 pt-2 pt-sm-0';
	
	const button = document.createElement('a');
	buttonColumn.appendChild(button);	
	button.className = "button colour-secondary auto-link";
	button.href = eventData.link;
	button.innerHTML = 'See event';

	const buttonBackground = document.createElement('div');
	button.appendChild(buttonBackground);
	buttonBackground.className = "button-background";

}